import React from 'react'
import PropTypes from 'prop-types'
import {
  GridImg,
  GridMediaWrapper,
  GridQuote,
  GridVideo,
} from './NewsGallery.styles'
import QuoteCard from '../../components/QuoteCard'

const NewsGalleryCard = ({ media, className, vertical, stretch }) => {
  const isQuote = media.quote ? true : false

  return (
    <GridMediaWrapper
      className={className}
      vertical={vertical}
      stretch={stretch}
    >
      {/* Quote content */}
      {isQuote && (
        <GridQuote>
          <QuoteCard
            className="rounded"
            newsGallery
            variant="gray"
            quote={media.quote}
            source={media.title}
            role={media.role}
          />
        </GridQuote>
      )}

      {/* Media content */}
      {!isQuote && media?.mimeType.includes('image') && (
        <GridImg simple src={media?.url} alt={media?.fileName} />
      )}
      {!isQuote && media?.mimeType.includes('video') && (
        <GridVideo src={media?.url} playsInline muted autoPlay loop />
      )}
    </GridMediaWrapper>
  )
}

export default NewsGalleryCard

NewsGalleryCard.propTypes = {
  media: PropTypes.object,
  className: PropTypes.string,
  vertical: PropTypes.bool,
}
